module.exports = __webpack_public_path__ + "img/07.feb26285.png";